import { ActivityAthlete } from 'oas';

export const athleteInActivitySorter = (a: ActivityAthlete, b: ActivityAthlete) =>
    a.last_name?.localeCompare(b.last_name || '') ||
    a.first_name?.localeCompare(b.first_name || '') ||
    a.jersey?.localeCompare(b.jersey || '') ||
    (a.device_info?.device_id || 0) - (b.device_info?.device_id || 0);
